// client/src/components/MerchantAbonnement.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import MerchantNavbar from './MerchantNavbar';
import { FaArrowLeft } from 'react-icons/fa';

const MerchantAbonnement = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/merchantsettings');
  };

  return (
    <div>
      <MerchantNavbar />
      <div className="dashboard-container sub-theme">
        <div className="sub-wrap">
          <button
            onClick={handleBackClick}
            className="sub-btn ghost eb-btn eb-btn--ghost eb-btn--sm"
          >
            <FaArrowLeft /> Retour
          </button>

          <header className="eb-page-header" style={{ marginTop: 12 }}>
            <div>
              <h1 className="eb-page-title">Abonnement</h1>
              <p className="eb-page-subtitle">Gérez votre formule et vos moyens de paiement</p>
            </div>
          </header>

          <section className="eb-card sub-card">
            <div className="eb-card__head">
              <h3 className="eb-card__title sub-card-title">Consulter les informations de mon abonnement</h3>
            </div>
            <div className="eb-card__body">
              <div className="eb-row sub-row">
                <div className="eb-row__main">
                  <p className="sub-card-text">
                    Factures, moyen de paiement et formule sont accessibles depuis l'espace client sécurisé Stripe.
                  </p>
                </div>
                <div className="eb-row__actions">
                  <a
                    href="https://billing.stripe.com/p/login/5kQ3cw1yof0q44HgWS3Ru00"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sub-btn primary sub-cta eb-btn eb-btn--primary"
                  >
                    Mon abonnement
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
          .sub-theme .sub-wrap { width: 100%; }
          .sub-theme .eb-page-title { margin: 0; text-align: left; }
          .sub-theme .sub-btn.ghost { padding-left: 8px; }
          .dashboard-container .sub-card .sub-card-title { margin: 0; font-size: 15px; text-align: left; }
          .sub-card .eb-card__body { padding: 4px 20px; }
          .sub-card .sub-card-text { margin: 0; font-size: 14px; color: var(--eb-muted); text-align: left; }
          @media (max-width: 768px) {
            .sub-card .eb-card__body { padding: 4px 16px; }
            .sub-card .eb-row__actions, .sub-card .sub-cta { width: 100%; }
          }
        `,
        }}
      />
    </div>
  );
};

export default MerchantAbonnement;
